import { type ReactNode, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { ToastProvider } from './components/toast';
import { RotaProtegida } from './components/RotaProtegida';
import { useAuth } from './lib/auth';
import { registrarExpiracaoSessao } from './lib/http';
import { guardarDestino } from './lib/session';
import { CampanhaPagina } from './routes/Campanha';
import { CadastroPagina } from './routes/Cadastro';
import { ClienteFichaPagina } from './routes/ClienteFicha';
import { ClientesPagina } from './routes/Clientes';
import { DashboardPagina } from './routes/Dashboard';
import { LoginPagina } from './routes/Login';
import { NotificacoesPagina } from './routes/Notificacoes';
import { PrimeiroAcessoPagina } from './routes/PrimeiroAcesso';
import { RecuperarPagina } from './routes/Recuperar';
import { VouchersPagina } from './routes/Vouchers';

export function App(): ReactNode {
  const navigate = useNavigate();
  const { encerrarLocal } = useAuth();

  useEffect(() => {
    registrarExpiracaoSessao(() => {
      guardarDestino(window.location.pathname + window.location.search);
      encerrarLocal();
      navigate('/login?expirada=1', { replace: true });
    });
  }, [navigate, encerrarLocal]);

  return (
    <ToastProvider>
      <Routes>
        <Route path="/login" element={<LoginPagina />} />
        <Route path="/primeiro-acesso" element={<PrimeiroAcessoPagina />} />
        <Route path="/recuperar" element={<RecuperarPagina />} />

        <Route
          path="/"
          element={
            <RotaProtegida>
              <CadastroPagina />
            </RotaProtegida>
          }
        />
        <Route
          path="/notificacoes"
          element={
            <RotaProtegida>
              <NotificacoesPagina />
            </RotaProtegida>
          }
        />
        <Route
          path="/clientes"
          element={
            <RotaProtegida>
              <ClientesPagina />
            </RotaProtegida>
          }
        />
        <Route
          path="/clientes/:id"
          element={
            <RotaProtegida>
              <ClienteFichaPagina />
            </RotaProtegida>
          }
        />
        <Route
          path="/vouchers"
          element={
            <RotaProtegida>
              <VouchersPagina />
            </RotaProtegida>
          }
        />
        <Route
          path="/dashboard"
          element={
            <RotaProtegida>
              <DashboardPagina />
            </RotaProtegida>
          }
        />
        <Route
          path="/campanha"
          element={
            <RotaProtegida papel="admin">
              <CampanhaPagina />
            </RotaProtegida>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ToastProvider>
  );
}
